import {LabelPrintingMethod} from 'graphql-client/__generated/graphqlGlobalTypes';

export {LabelPrintingMethod};

export const LEGACY_PRINTING_METHODS: Array<LabelPrintingMethod> = [
  LabelPrintingMethod.REMOTE_PRINT_SERVER,
  LabelPrintingMethod.LEGACY_HTTP,
  LabelPrintingMethod.LEGACY_TCP,
];

export const LABEL_PRINTING_METHOD_TO_DISPLAY_STRING: {[method in LabelPrintingMethod]: string} = {
  [LabelPrintingMethod.BARTENDER]: 'BarTender',
  [LabelPrintingMethod.ZEBRA_BROWSER_PRINT]: 'Zebra browser print',
  [LabelPrintingMethod.REMOTE_PRINT_SERVER]: 'Remote print application',
  [LabelPrintingMethod.LEGACY_HTTP]: 'Legacy HTTP print',
  [LabelPrintingMethod.LEGACY_TCP]: 'Legacy TCP print',
};

export function getTenantLevelLabelPrintingSettingsURL(): string {
  return '/label-printing-settings';
}
